import moment from 'moment'
import React, { FunctionComponent, useRef } from 'react'

import { ReactComponent as FilterIcon } from '../../atoms/Icons/filterIcon.svg'
import * as S from './styled'

type OwnProps = {
  setStartDate: React.Dispatch<React.SetStateAction<Date>>
  setEndDate: React.Dispatch<React.SetStateAction<Date>>
  setShowCalender: React.Dispatch<React.SetStateAction<boolean>>
  setStartDateLocal: React.Dispatch<React.SetStateAction<Date>>
  setEndDateLocal: React.Dispatch<React.SetStateAction<Date>>
  startDate: Date
  endDate: Date
}

type Props = OwnProps

export const TimePeriodBoxDropdown: FunctionComponent<Props> = ({
  setStartDate,
  setEndDate,
  setShowCalender,
  setStartDateLocal,
  setEndDateLocal,
  startDate,
  endDate,
}) => {
  const selectBox = useRef<HTMLSelectElement>(null)
  const timePeriodOptions = ['Vecka', 'Månad', 'År', 'Allt', 'Välj']
  function changeHandler(event) {
    switch (event.target.value) {
      case 'Vecka':
        setStartDate(moment().subtract(7, 'days').toDate())
        setEndDate(new Date())
        setShowCalender(false)
        break
      case 'Månad':
        setStartDate(moment().subtract(1, 'month').toDate())
        setEndDate(new Date())
        setShowCalender(false)
        break
      case 'År':
        setStartDate(moment().subtract(1, 'year').toDate())
        setEndDate(new Date())
        setShowCalender(false)
        break
      case 'Allt':
        setStartDate(moment().subtract(12, 'year').toDate())
        setEndDate(new Date())
        setShowCalender(false)
        break
      case 'Välj':
        setShowCalender(true)
        setStartDateLocal(startDate)
        setEndDateLocal(endDate)
        break
    }
  }
  return (
    <S.Card>
      <S.Text>
        <FilterIcon />
      </S.Text>
      <S.DropDown
        ref={selectBox}
        onChange={changeHandler}
        onFocus={() => {
          selectBox.current!.selectedIndex = -1
        }}
        defaultValue={'År'}
      >
        {timePeriodOptions.map(item => {
          if (item === 'Välj') {
            // const date1 = moment(startDate).toLocaleString()
            return (
              <option key={item} value={item}>
                {moment(startDate).format('YYMMDD')} - {moment(endDate).format('YYMMDD')}
              </option>
            )
          } else {
            return (
              <option key={item} value={item}>
                {item}
              </option>
            )
          }
        })}
      </S.DropDown>
    </S.Card>
  )
}

export default TimePeriodBoxDropdown
